export var LocationType;
(function (LocationType) {
    LocationType[LocationType["VENUE"] = 0] = "VENUE";
    LocationType[LocationType["ONLINE"] = 1] = "ONLINE";
})(LocationType || (LocationType = {}));
